function cov_28nckfidn1() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/GeoFilled.tsx";
  var hash = "dc44967ae4c2fb6bef1f8f10122201608d13919d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/GeoFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 50
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dc44967ae4c2fb6bef1f8f10122201608d13919d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28nckfidn1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28nckfidn1();
var Icon = (cov_28nckfidn1().s[0]++, {
  name: 'geo-filled',
  svg: "<path d=\"M20.9516 2.34387L2.5689 6.42653C1.77042 6.60386 1.67097 7.70195 2.4246 8.01985L11.2724 11.7521L13.3493 20.8655C13.5324 21.6693 14.6435 21.7553 14.9481 20.9892L21.9138 3.47384C22.1629 2.84748 21.6096 2.19772 20.9516 2.34387Z\" fill=\"currentColor\"/>"
});
export default Icon;